export default __webpack_public_path__ + "static/media/full4.0ae27b33.svg";